import * as Yup from "yup";
import { type AccountTypeEnum } from "../../../../graphql/supergraphTypes";
import { JointFormValues } from "./types";

export const createJointFormSchema = (): Yup.ObjectSchema<JointFormValues> => {
  return Yup.object({
    legalBusinessName: Yup.string().required("Legal business name is required"),
    accountType: Yup.mixed<AccountTypeEnum>().required("Joint ownership type is required"),
    country: Yup.string().required("Domicile country is required"),
  });
};
